import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/layout-dashboard.vue
var o = {
	name: "DtIconLayoutDashboard",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--layout-dashboard"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Layout Dashboard",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M1 1.5a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5H1.5A.5.5 0 0 1 1 6V1.5ZM2 2v3.5h2.5V2H2Zm4.5-.5A.5.5 0 0 1 7 1h3.5a.5.5 0 0 1 .5.5V4a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V1.5Zm1 .5v1.5H10V2H7.5Zm-1 4a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 .5.5v4.5a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V6Zm1 .5V10H10V6.5H7.5ZM1 8a.5.5 0 0 1 .5-.5H5a.5.5 0 0 1 .5.5v2.5a.5.5 0 0 1-.5.5H1.5a.5.5 0 0 1-.5-.5V8Zm1 .5V10h2.5V8.5H2Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=layout-dashboard.js.map